export const fontSize = [12, 14, 16, 18, 24, 32, 48, 64, 72]
export const fontWeight = [300, 400, 500, 600, 700]
